import { fromLonLat } from 'ol/proj';
import BingMaps from 'ol/source/BingMaps';
import Feature from 'ol/Feature';
import Icon from 'ol/style/Icon';
import Map from 'ol/Map';
import Overlay from 'ol/Overlay';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';

// Converts from degrees, minutes to coordinates
function dm2d(deg, min) {
    return deg + min / 60;
}

const baseMap = new TileLayer({
    source: new BingMaps({
        key: 'At3leT_ngMNMwg6lic90p_uhJZMO7yDtH5W8EKGdQ3UMGpQ-T_sU7fIX13-rSNCU',
        imagerySet: 'AerialWithLabelsOnDemand'
    })
});

const vectorSource = new VectorSource({
});

const vectorLayer = new VectorLayer({
    source: vectorSource,
});

const overlay = new Overlay({
    element: document.getElementById('popup'),
    autoPan: {
        animation: {
            duration: 250,
        },
    },
});

const map = new Map({
    layers: [
        baseMap,
        vectorLayer
    ],
    overlays: [overlay],
    target: 'map',
    view: new View({
        center: fromLonLat([dm2d(10, 4.554), dm2d(56, 41.433)]),
        zoom: 14
    })
});

map.on('singleclick', (event) => {
    let text = null;
    map.forEachFeatureAtPixel(event.pixel, (feature) => {
        text = feature.get('description');
    },
    {
        hitTolerance: 10
    });
    if (text) {
        document.getElementById('popup-content').innerHTML = text;
        overlay.setPosition(event.coordinate);
    } else {
        overlay.setPosition(undefined);
    }
});

document.getElementById('popup-closer').addEventListener('click', event => {
    overlay.setPosition(undefined);
    event.target.blur();
    return false;
});
class Mark {
    constructor(id, lat, lon, txt) {
        this.id = id;
        this.name = id;
        if (id > 0) {
            this.feature = new Feature({
                geometry: new Point(fromLonLat([lon, lat])),
                description: txt
            });
            this.feature.setStyle(new Style({
                image: new Icon({
                    anchorOrigin: 'bottom-left',
                    src: `data/${id}.png`
                })
            }));
            vectorSource.addFeature(this.feature);
        }
    }
}

const marks = [];
marks[0] = new Mark(0, dm2d(56, 41.452), dm2d(10, 4.555), null);  // end of starting line
marks[1] = new Mark(1, dm2d(56, 41.433), dm2d(10, 4.554), "Start og mål er ved Nybrogårds mole, mellem to udlagte mærker<br>(N 56°41.433 – E 10°04.554)");
marks[2] = new Mark(2, dm2d(56, 41.965), dm2d(10, 4.070), "Udlagt mærke Nybrogårdsvej (sejlunionens ankerbøje)<br>(N 56°41.965 – E 10°04.070)");
marks[3] = new Mark(3, dm2d(56, 41.096), dm2d(10, 5.041), "Udlagt mærke ved Ballegård (sejlunionens ankerbøje)<br>(N 56°41.096 – E 10°05.041)");
marks[4] = new Mark(4, dm2d(56, 41.610), dm2d(10, 3.476), "Sydlig kompas ved Skarodde<br>(N 56°41.610 – E 10°03.476)");
marks[5] = new Mark(5, dm2d(56, 41.517), dm2d(10, 5.846), "Rød kost ved Aamølle<br>(N 56°41.517 – E 10°05.846)");
marks[6] = new Mark(6, dm2d(56, 41.251), dm2d(10, 4.015), "Rød kost nærmest Kongsdal<br> (N 56°41.251 – E 10°04.015)");

class Course {
    constructor(wind, arrow, ids) {
        this.wind = wind;
        this.arrow = arrow;
        this.ids = ids;
        this.text = "";
        this.text = ids.map(id => marks[id].name).join(' &#10230; ');
    }
}

const courses = [];
courses[0] = new Course("80° - 121°", "&#8656;", [1, 5, 4, 1]);
courses[1] = new Course("260° - 301°", "&#8658;", [1, 4, 5, 1]);
courses[2] = new Course("121° - 200°", "&#8662;", [1, 3, 2, 1]);
courses[3] = new Course("301° - 20°", "&#8664;", [1, 2, 3, 1]);
courses[4] = new Course("20° - 80°", "&#8665;", [1, 5, 6, 1]);
courses[5] = new Course("200° - 260°", "&#8663;", [1, 6, 5, 1]);

function getSelected(name) {
    for (let radio of document.getElementsByName(name)) {
        if (radio.checked) {
            return radio.value;
        }
    }
}

function update() {
    let course = getSelected('course');
    let direction = getSelected('direction');
    let id = (course << 1) | direction;
    document.getElementById('arrow').innerHTML = courses[id].arrow;
    document.getElementById('marks').innerHTML = courses[id].text;
    document.getElementById('wind').innerHTML = courses[id].wind;
}

for (let input of document.getElementsByTagName('input')) {
    input.addEventListener('change', update);
}

update();
